import OneThirdCardLayout from '@/components/CustomCard/OneThirdCardLayout';
import { images, LINK, PATH } from '@/constants';
import EditTrackingUrlButton from '@/components/EditTrackingUrlButton';
import useTrackingPageUrl from '@/hooks/useTrackingPageUrl';
import { PolarisBreakPoint } from '@/constants/enum';
import { CopyIcon } from '@/icons';
import { tokenSelector } from '@/redux/features/auth.slice';
import { Button, ButtonGroup, InlineStack, Link, Text, TextField } from '@shopify/polaris';
import { useSelector } from 'react-redux';
import useConfirmationNavigate from '@/hooks/useConfirmationNavigate';
import styled from 'styled-components';

const TrackingPageEditorImageWrapper = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media only screen and (max-width: ${PolarisBreakPoint.MD}) {
    & {
      max-height: 100%;
    }
  }
`;

const TrackingPageEditor = () => {
  const navigate = useConfirmationNavigate();
  const { shop } = useSelector(tokenSelector);

  const { url: storefrontLink } = useTrackingPageUrl();

  return (
    <>
      <OneThirdCardLayout
        padding="0"
        title="Tracking page editor"
        subTitle={'Customize tracking information, style, and more.'}
        contentRight={<TrackingPageEditorImageWrapper src={images.trackingPageEditor} alt="tracking page editor" />}
      >
        <div className="d-flex gap-16 flex-column">
          <ButtonGroup>
            <Button variant="primary" onClick={() => navigate(PATH.TRACKING_CONFIGURATION_PAGE)}>
              Customize
            </Button>
            <Button url={storefrontLink}>View</Button>
          </ButtonGroup>
          <div>
            <div className="mb-4">
              <Text variant="bodyMd" as="h6" tone="subdued">
                URL
              </Text>
            </div>
            <InlineStack gap="200" wrap={false} blockAlign="center">
              <div style={{ flex: 1 }}>
                <TextField
                  autoComplete="off"
                  label="URL"
                  labelHidden
                  value={storefrontLink}
                  readOnly
                  suffix={<CopyIcon copiedText={storefrontLink} />}
                />
              </div>
              <EditTrackingUrlButton />
            </InlineStack>
          </div>
          <Text variant="bodyMd" as="p">
            Go to{' '}
            <Link monochrome url={LINK.SHOPIFY_MENU(shop)}>
              Store menus
            </Link>
            , choose a menu and add this link as a menu item.
          </Text>
        </div>
      </OneThirdCardLayout>
    </>
  );
};

export default TrackingPageEditor;
